import type { FC, PropsWithChildren } from 'react';
import ButtonStyles from './SimpleButton.module.css';

type SimpleButtonProps = PropsWithChildren<{
  label: string;
  disabled?: boolean;
  type?: 'submit' | 'button' | 'reset';
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}>;

const SimpleButton: FC<SimpleButtonProps> = props => {
  return (
    <button
      className={props.disabled ? ButtonStyles.button_disabled : ButtonStyles.button}
      disabled={props.disabled}
      type={props.type}
      style={props.style}
      onClick={props.onClick}
    >
      {props.label}
    </button>
  );
};

export default SimpleButton;
